// extracted by mini-css-extract-plugin
module.exports = {"Quote":"Quote_Quote__waxnf","content":"Quote_content__zJiZD","author":"Quote_author__8vor8","QuoteIcon":"Quote_QuoteIcon__Etd0S"};